import React from "react";

import { DashboardPageBody } from "../../components/Page";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import SourceSystemsPage from "./ui";

const SourceSystems = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <DashboardPageBody>
        <SourceSystemsPage />
      </DashboardPageBody>
    </DashboardLayout>
  );
};

export default SourceSystems;
